/**
 * Parsowanie fragmentu XML z BFF (string z tablicy data.row / data.linia).
 *
 * Fragment przychodzi z literalnymi tagami i encjami w treści (&amp; itd.) —
 * DOMParser sam dekoduje encje w textContent. Wcześniejsze pre-dekodowanie
 * &amp; -> & PRZED parsowaniem psuło well-formedness i po cichu gubiło wiersze
 * z "&" w danych (np. towar "Regenflex T&M", partner "KIRYLUK&WENTA").
 * Fallback obsługuje legacy kształt, w którym cały fragment jest zescapowany
 * (&lt;tag&gt;...&lt;/tag&gt;).
 */
/**
 * Dekoduje encje XML w wartości WYCIĘTEJ regexem z fragmentu BFF (leaf-text,
 * nie cały fragment — dekodowanie całego fragmentu psuje well-formedness,
 * patrz parseXmlFragment). Czysty odpowiednik decodeXmlEntities z
 * composables/usePartnerContext — do modułów bez zależności od axios/Pinia.
 */
export function decodeXmlEntities(s: string): string {
  return s
    .replace(/&quot;/g, '"')
    .replace(/&apos;/g, "'")
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&amp;/g, '&');
}

export function parseXmlFragment(item: string): Document {
  const parser = new DOMParser();
  const doc = parser.parseFromString('<root>' + item + '</root>', 'text/xml');
  const ok = !doc.querySelector('parsererror');
  // legacy: caly fragment zescapowany — parsuje sie "poprawnie", ale jako sama
  // tresc tekstowa bez elementow; wtedy trzeba odtworzyc tagi
  const legacyShape = ok && doc.documentElement.childElementCount === 0 && item.includes('&lt;');
  if (ok && !legacyShape) return doc;
  const decoded = item
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&amp;/g, '&');
  const doc2 = parser.parseFromString('<root>' + decoded + '</root>', 'text/xml');
  return doc2.querySelector('parsererror') && ok ? doc : doc2;
}
